import { ReactComponent as Subscription } from "./material-symbols_confirmation-number-outline-rounded.svg";
import { ReactComponent as AebImg } from "./material-symbols_restaurant-rounded.svg";
import { ReactComponent as AerialImg } from "./material-symbols_airplane-ticket-outline.svg";
import { ReactComponent as ComunicationImg } from "./material-symbols_signpost-outline-rounded.svg";
import { ReactComponent as EquipmentImg } from "./material-symbols_home-repair-service-rounded.svg";
import { ReactComponent as RSVPImg } from "./rsvp.svg";
import { ReactComponent as SupportImg } from "./support.svg";
import { ReactComponent as TotalsImg } from "./totals.svg";
import { ReactComponent as TransferImg } from "./transfer.svg";
import { ReactComponent as TranslationImg } from "./material-symbols_translate-rounded.svg";
import { ReactComponent as AcommodationImg } from "./acommodations.svg";
import { ReactComponent as OthersImg } from "./several.svg";
import { ReactComponent as PRODUCTION_SUPPORTImg } from "./material-symbols_support-agent-rounded.svg";
import { ReactComponent as ATTRACTIONImg } from "./material-symbols_add-reaction-outline.svg";
import { ReactComponent as BRINDES_INCENTIVOS_PREMIACOESImg } from "./material-symbols_featured-seasonal-and-gifts.svg";
import { ReactComponent as CONTENTImg } from "./material-symbols_video-library.svg";
import { ReactComponent as FOTO_VIDEOImg } from "./material-symbols_video-camera-back.svg";
import { ReactComponent as LICENCES_TAXESImg } from "./material-symbols_percent.svg";
import { ReactComponent as GRAPHIC_MATERIALImg } from "./material-symbols_photo-prints.svg";
import { ReactComponent as MOUNTING_COMPANYImg } from "./material-symbols_stacked-inbox.svg";
import { ReactComponent as NECESSARY_ADDITIONSImg } from "./material-symbols_add-box.svg";
import { ReactComponent as HUMAN_RESOURCES_STAFFImg } from "./material-symbols_person-book.svg";
import { ReactComponent as TRAVEL_INSURANCEImg } from "./material-symbols_api.svg";
import { ReactComponent as SERVICE_SUPPORTImg } from "./material-symbols_handshake.svg";
import { ReactComponent as EVENT_INSURANCEImg } from "./material-symbols_calendar-month.svg";
import { ReactComponent as TECHNOLOGYImg } from "./material-symbols_tv-options-input-settings.svg";
import { ReactComponent as CENOGRAPHY_DECORATIONImg } from "./material-symbols_star-shine.svg";
import { ReactComponent as PARKINGImg } from "./material-symbols_directions-car.svg";

interface StringMap {
  [key: string]: any;
}
export const BudgetIcons: StringMap = {
  ACCOMMODATIONS: <AcommodationImg />,
  ROOMS: <Subscription />,
  AEB: <AebImg />,
  EQUIPMENTS: <EquipmentImg />,
  TRANSLATIONS: <TranslationImg />,
  SUPPORT: <SupportImg />,
  SUBSCRIPTION: <Subscription />,
  RSVP: <RSVPImg />,
  AIR: <AerialImg />,
  TRANSFER: <TransferImg />,
  COMMUNICATIONS: <ComunicationImg />,
  SEVERAL: <OthersImg />,
  TOTALS: <TotalsImg />,
  ATTRACTION: <ATTRACTIONImg />,
  PRODUCTION_SUPPORT: <PRODUCTION_SUPPORTImg />,
  BRINDES_INCENTIVOS_PREMIACOES: <BRINDES_INCENTIVOS_PREMIACOESImg />,
  CENOGRAPHY_DECORATION: <CENOGRAPHY_DECORATIONImg />,
  CONTENT: <CONTENTImg />,
  FOTO_VIDEO: <FOTO_VIDEOImg />,
  LICENCES_TAXES: <LICENCES_TAXESImg />,
  GRAPHIC_MATERIAL: <GRAPHIC_MATERIALImg />,
  MOUNTING_COMPANY: <MOUNTING_COMPANYImg />,
  NECESSARY_ADDITIONS: <NECESSARY_ADDITIONSImg />,
  HUMAN_RESOURCES_STAFF: <HUMAN_RESOURCES_STAFFImg />,
  TRAVEL_INSURANCE: <TRAVEL_INSURANCEImg />,
  SERVICE_SUPPORT: <SERVICE_SUPPORTImg />,
  EVENT_INSURANCE: <EVENT_INSURANCEImg />,
  TECHNOLOGY: <TECHNOLOGYImg />,
  PARKING: <PARKINGImg />,
};
